import { Container, Text } from '@chakra-ui/react';
import { getTranslations } from 'next-intl/server';

import { ResetPasswordContainer } from '@/modules/authentication/presentation/containers';

type ResetPasswordScreenProps = {
	oobCode: string
};

export const ResetPasswordScreen = async ({ oobCode }: ResetPasswordScreenProps) => {
	const t = await getTranslations('authentication.resetPassword');

	return (
		<Container display="grid" gap="md" maxW="xl">
			<Text textAlign="center" textStyle="h1">
				{t('title')}
			</Text>
			<ResetPasswordContainer oobCode={oobCode} />
		</Container>
	);
};
